import AccountCircle from '@material-ui/icons/AccountCircle';
import BackButton from '@material-ui/icons/ChevronLeft';
import Customer from 'models/Customer';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	root: {
		padding: 8,
		marginBottom: 7,
	},
	leftDrawerClose: {
		position: 'absolute',
		top: -8,
		right: 0,
	},
	accountIcon: {
		width: 64,
		height: 64,
		viewBox: '0 0 18 18',
		color: theme.palette.common.black,
	},
	customerName: {
		fontSize: '15pt',
		lineHeight: '1.6em',
	},
	customerEmail: {
		fontSize: '9pt',
		lineHeight: '1.6em',
		paddingBottom: -8,
	},
	backButton: {
		height: 35,
		width: 35,
		color: theme.palette.common.black,
	},
	iconButton: {
		backgroundColor: 'transparent',
		left: 5,
		top: 4,
		color: 'inherit',
	},
});

const MainDrawerLeftIcons = props => {
	const { classes, customer, closeDrawer } = props;
	return (
		<div className={classes.root}>
			<div className={classes.leftDrawerClose}>
				<IconButton className={classes.iconButton} onClick={closeDrawer} >
					<BackButton className={classes.backButton} />
				</IconButton>
			</div>
			{!customer.isGuest ? (
				<div>
					<AccountCircle className={classes.accountIcon} />
					<div style={{ position: 'relative', top: '-4px' }}>
						<Typography className={classes.customerName}>{customer.fullName}</Typography>
						<Typography className={classes.customerEmail}>{customer.emailAddress}</Typography>
					</div>
				</div>
			) : null}
		</div>
	);
};

MainDrawerLeftIcons.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		leftDrawerClose: PropTypes.string,
		customerName: PropTypes.string,
		customerEmail: PropTypes.string,
		iconButton: PropTypes.string,
		backButton: PropTypes.string,
	}).isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	closeDrawer: PropTypes.func.isRequired,
};

export default withStyles(styles, { name: 'MainDrawerLeftIcons' })(MainDrawerLeftIcons);
